import axiosInstance from '@/utils/api.js'

var state = {
  NASlist: []
}

var getters = {
  NAS_LIST: (state) => {
    return state.NASlist
  }
}

var mutations = {
  SET_NAS_LIST: (state, payload) => {
    state.NASlist = payload
  }
}

var actions = {
  GET_NAS_LIST: async (context, payload) => {
    let result = await axiosInstance.get('/settings/nases')
    if (result.status === 200) {
      context.commit('SET_NAS_LIST', result.data)
    }
  },
  CREATE_NAS_LIST: (context, payload) => {
    return axiosInstance.post('/settings/nases', payload)
  },
  UPDATE_NAS_LIST: (context, payload) => {
    return axiosInstance.put('/settings/nases', payload)
  },
  DELETE_NAS_LIST: (context, payload) => {
    return axiosInstance.delete('/settings/nases?nas_id=' + payload)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/stores/settings/NASlist.js